import { z } from 'zod';

/**
 * URL search params for the Home logada (`/vagas`). `tab` selects Minhas/Novas;
 * `q` is the (cumulative) text search; `status` is the Minhas-only filter; the
 * remaining five dimensions are the Novas filter (same set as the Home
 * deslogada). Search + filters live in the URL so they are bookmarkable, but
 * switching tabs drops every param except `tab` (RN-13 / RN-22) — the
 * container navigates with `{ tab }` only.
 */
export const myJobsSearchSchema = z.object({
  tab: z.enum(['minhas', 'novas']).optional().catch(undefined),
  q: z.string().optional().catch(undefined),
  // Minhas filter (RN-11)
  status: z.string().optional().catch(undefined),
  // Novas filter (RN-20)
  jobType: z.string().optional().catch(undefined),
  workModel: z.string().optional().catch(undefined),
  workload: z.string().optional().catch(undefined),
  state: z.string().optional().catch(undefined),
  city: z.string().optional().catch(undefined),
});

export type MyJobsSearch = z.infer<typeof myJobsSearchSchema>;

export type HomeTab = 'minhas' | 'novas';
